import { render } from "./index.vue?vue&type=template&id=04640ac2"
import script from "./login.ts?vue&type=script&lang=js"
export * from "./login.ts?vue&type=script&lang=js"

import "./login.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script